import { IFundingCategoryAssemblyJunction } from '../../interfaces/ifunding-category-assembly-junction';
import { FundingCategoryAssembly } from '../funding-category-assembly';

export class FundingCategoryAssemblyJunctionBase {
  FundingCategoryAssemblyJunctionId: number;
  FundingCategoryId: number;
  FundingCategoryAssemblyId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FundingCategoryAssembly?: FundingCategoryAssembly;

  constructor(item?: IFundingCategoryAssemblyJunction) {
    if (item) {

      this.FundingCategoryAssemblyJunctionId = item.FundingCategoryAssemblyJunctionId;
      this.FundingCategoryId = item.FundingCategoryId;
      this.FundingCategoryAssemblyId = item.FundingCategoryAssemblyId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FundingCategoryAssembly = new FundingCategoryAssembly(item.FundingCategoryAssembly);
    }
  }
}